import React from 'react';
import PropTypes from 'prop-types';

const CommandsLeft = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <div className="bhp-left">
      <div className="bhp-commands">{children}</div>
    </div>
  );
};
CommandsLeft.propTypes = {
  children: PropTypes.any.isRequired
};

const CommandsCenter = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <div className="bhp-center">
      <div className="bhp-commands">{children}</div>
    </div>
  );
};
CommandsCenter.propTypes = {
  children: PropTypes.any.isRequired
};

const CommandsRight = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <div className="bhp-right">
      <div className="bhp-commands">{children}</div>
    </div>
  );
};
CommandsRight.propTypes = {
  children: PropTypes.any.isRequired
};

class ToolBar extends React.Component {
  static Left = CommandsLeft;

  static Center = CommandsCenter;

  static Right = CommandsRight;

  render() {
    const { children } = this.props;
    return <div className="bhp-tool-bar">{children}</div>;
  }
}

ToolBar.propTypes = {
  children: PropTypes.any.isRequired
};

export default ToolBar;
